import { Navigate, useRoutes } from "react-router-dom";
import Base from "./Base";
import AboutSGFIN from "./pages/AboutSGFIN";
import FeedbackChatPage from "./pages/feedback_pages/FeedbackChatPage";
import FeedbackFormPage from "./pages/feedback_pages/FeedbackFormPage";
import FeedbackHome from "./pages/feedback_pages/FeedbackHome";
import Homepage from "./pages/Homepage";
import LeaderboardPage from "./pages/LeaderboardPage";
import CreateAccount from "./pages/login_pages/CreateAccount";
import ForgetPassword from "./pages/login_pages/ForgetPassword";
import LoginPage from "./pages/login_pages/LoginPage";
import LogoutPage from "./pages/login_pages/LogoutPage";
import PrivacyPolicy from "./pages/login_pages/PrivacyPolicy";
import TermsAndCon from "./pages/login_pages/TermsAndCon";
import MaintenancePage from "./pages/MaintenancePage";
import EditLifestylePage from "./pages/profile_pages/EditLifestylePage";
import RewardPage from "./pages/RewardPage";
import ScanLandingPage from "./pages/ScanLandingPage";

const isUnderMaintenance = false;
export default function Router() {
    return useRoutes([
    isUnderMaintenance ?
    {
        path: "/",
        element: <Base />,
        children: [
            {
                path: "/",
                element: <MaintenancePage />,
            },
        ]
    }
    :
    {
        path: "/",
        element: <Base />,
        children: [
            {
                path: "/",
                element: <Homepage />,
            },
            {
                path: "/profile",
                children: [
                    {
                        path: "/profile",
                        element: <Navigate to="/" />,
                    },
                    {
                        path: "/profile/edit/*",
                        element: <EditLifestylePage />,
                    },
                    {
                        path: "/profile/leaderboard",
                        element: <LeaderboardPage />,
                    },
                    {
                        path: "/profile/rewards",
                        element: <RewardPage />,
                    },
                ]
            },
            {
                path: "/new-user",
                element: <CreateAccount />,
            },
            {
                path: "/login",
                children: [
                    {
                        path: "/login",
                        element: <LoginPage />,
                    },
                    {
                        path: "/login/reset-password",
                        element: <ForgetPassword />,
                    },
                ]
            },
            {
                path: "/logout",
                element: <LogoutPage />,
            },
            {
                path: "/terms-and-conditions",
                element: <TermsAndCon />,
            },
            {
                path: "/feedback",
                children: [
                    {
                        path: "/feedback",
                        element: <FeedbackHome />,
                    },
                    {
                        path: "/feedback/form",
                        element: <FeedbackFormPage />,
                    },
                    {
                        path: "/feedback/chat",
                        element: <FeedbackChatPage />,
                    },
                ]
            },
            {
                path: "/about-sgfin",
                element: <AboutSGFIN />,
            },
            {
                path: "/site",
                element: <ScanLandingPage />,
            },
            {
                path: "*",
                element: <Navigate to="/login" />,
            },
        ]
    },
    {
        path: "/privacy-policy",
        element: <PrivacyPolicy />,
    },
    ]);
}
